import Tabs from './components/Tabs';
import TabList from './components/TabList';
import Tab from './components/Tab';
import TabPanel from './components/TabPanel';
import { reset as resetIdCounter } from './helpers/uuid';
export { Tab, TabList, TabPanel, Tabs, resetIdCounter };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tabs/esm/index.js
// module id = 1007
// module chunks = 0